import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function PopularSection() {
  const popularMovies = movies
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门<strong>推荐</strong>
            </h2>
            <p className="mt-1 text-sm text-foreground-500">高分好评，大家都在看</p>
          </div>
          <Link
            to="/category/tv"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {popularMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link to="/category/tv" className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}